import { AIAction, ExecutionLog, ApplyApprovedActionsResponse, DiscardAllActionsResponse, ConfirmAllActionsResponse, RevertAllActionsResponse } from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

export async function getActionsForInput(inputId: string): Promise<AIAction[]> {
    const response = await fetch(`${getApiBaseUrl()}/inputs/${inputId}/actions`);
    return handleResponse<AIAction[]>(response);
}

export async function approveAction(actionId: string): Promise<AIAction> {
  const response = await fetch(`${getApiBaseUrl()}/actions/${actionId}/approve`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return handleResponse<AIAction>(response);
}

export async function discardAction(actionId: string): Promise<AIAction> {
  const response = await fetch(`${getApiBaseUrl()}/actions/${actionId}/discard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return handleResponse<AIAction>(response);
}

export async function applyApprovedActions(inputId: string): Promise<ApplyApprovedActionsResponse> {
  const response = await fetch(`${getApiBaseUrl()}/inputs/${inputId}/apply-approved-actions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  // Status can be 200 or 207, handleResponse will parse JSON for both if ok.
  return handleResponse<ApplyApprovedActionsResponse>(response);
}

export async function discardAllProposedActions(inputId: string): Promise<DiscardAllActionsResponse> {
  const response = await fetch(`${getApiBaseUrl()}/inputs/${inputId}/discard-actions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
   // Status can be 200 or 207
   return handleResponse<DiscardAllActionsResponse>(response);
}

export async function getExecutionLogs(actionId: string): Promise<ExecutionLog[]> {
  const response = await fetch(`${getApiBaseUrl()}/actions/${actionId}/logs`);
  return handleResponse<ExecutionLog[]>(response);
}


// "Apply & Revert" specific API calls
export async function confirmKeepAction(actionId: string): Promise<AIAction> {
  const response = await fetch(`${getApiBaseUrl()}/actions/${actionId}/confirm-keep`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<AIAction>(response);
}

export async function revertAction(actionId: string): Promise<AIAction> {
  const response = await fetch(`${getApiBaseUrl()}/actions/${actionId}/revert`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<AIAction>(response); // Backend returns AIAction with logs
}

export async function executeAction(actionId: string): Promise<AIAction> {
  const response = await fetch(`${getApiBaseUrl()}/actions/${actionId}/execute`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<AIAction>(response);
}

export async function confirmAllAppliedActions(inputId: string): Promise<ConfirmAllActionsResponse> {
  const response = await fetch(`${getApiBaseUrl()}/inputs/${inputId}/confirm-all-actions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<ConfirmAllActionsResponse>(response);
}

export async function revertAllAppliedActions(inputId: string): Promise<RevertAllActionsResponse> {
  const response = await fetch(`${getApiBaseUrl()}/inputs/${inputId}/revert-all-actions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  // Status can be 200 or 207
  return handleResponse<RevertAllActionsResponse>(response);
}

export async function revertAiTurn(inputId: string): Promise<void> {
    const response = await fetch(`${getApiBaseUrl()}/ai-actions/${inputId}/revert`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    });
    await handleResponse<void>(response);
}